import { WOOT_PREFIX } from './constants';

export const isEmptyObject = obj =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

export const arrayToHashById = array =>
  array.reduce((map, obj) => {
    const newMap = map;
    newMap[obj.id] = obj;
    return newMap;
  }, {});

export const IFrameHelper = {
  isIFrame: () => window.self !== window.top,
  sendMessage: msg => {
    window.parent.postMessage(
      `chatwoot-widget:${JSON.stringify({ ...msg })}`,
      '*'
    );
  },
  isAValidEvent: e => {
    const isDataAString = typeof e.data === 'string';
    const isAValidWootEvent =
      isDataAString && e.data.indexOf(WOOT_PREFIX) === 0;
    return isAValidWootEvent;
  },
  getMessage: e => JSON.parse(e.data.replace(WOOT_PREFIX, '')),
  inIframe: () => {
    //Browsers can block access to window.top due to same origin policy.
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
};
export const RNHelper = {
  isRNWebView: () => window.ReactNativeWebView,
  sendMessage: msg => {
    window.ReactNativeWebView.postMessage(
      `chatwoot-widget:${JSON.stringify({ ...msg })}`
    );
  }
};

export const emailFormatter = value => {
  if (!value) return value;
  let parts = value.split('@');
  if (parts.length !== 2) return value;
  parts[1] = parts[1].toLowerCase();
  return parts.join('@');
};

export const getField = (fields, fieldKey) => {
  if (!Array.isArray(fields)) {
    return null;
  }
  return fields.filter(fields => fields.name == fieldKey);
};

export const isFieldRequired = fieldData => {
  return (
    Array.isArray(fieldData) && fieldData.length > 0 && fieldData[0].required
  );
};

export const isFieldEnabled = fieldData => {
  return (
    Array.isArray(fieldData) && fieldData.length > 0 && fieldData[0].enabled
  );
};

export const createDevLogger = prefixStr => (...args) => {
  if (localStorage.getItem('dev__logs') === 'true') {
    console.log(prefixStr, ...args);
  }
};

export const debounce = (func, delay) => {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
};